export class JuvenileSearchConstants {
    public static PAGE_SIZE = 50;
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-search-constants.ts